import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// src/components/BackgroundLogin.tsx
import React from 'react';
import backgroundImage from '@/images/1011_039.jpg';
import backgroundVideo from '@/videos/HM_sun.mp4';
import '@/styles/FallBackPage.css';
/**
 * BackgroundLogin component.
 *
 * This component displays either a background image or a background video based on the `useImageBackground` prop.
 *
 * @param {BackgroundProps} props - The props for the component.
 * @returns The BackgroundLogin component.
 */
const BackgroundFallBack = ({ useImageBackground }) => useImageBackground ? (_jsx("div", { className: "background-image", style: { backgroundImage: `url(${backgroundImage})` }, "data-testid": "background-image" })) : (_jsxs("video", Object.assign({ autoPlay: true, muted: true, loop: true, id: "background-video", className: "video-bg", "data-testid": "background-video" }, { children: [_jsx("source", { src: backgroundVideo, type: "video/mp4", "data-testid": "background-video-source" }), "Your browser does not support the video tag."] })));
export default BackgroundFallBack;
